import reviewStars from '../review-stars/review-stars.vue';
import reviewHelpful from '../review-helpful/review-helpful.vue';
import { yotpoMixin } from '../../mixins/yotpo-mixins';
//import axios from "axios";
import { Navigation, Pagination, Lazy, A11y, Zoom } from 'swiper';
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

export default {
  name: 'reviewCard',
  components: {
    Swiper,
    SwiperSlide,
    ReviewStars: reviewStars,
    ReviewHelpful: reviewHelpful,
  },
  setup() {
    const onSwiper = (swiper) => {};
    const onSlideChange = () => {
      //console.log('slide change');
    };
    return {
      pagination: {
        clickable: true,
      },
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Lazy, A11y, Zoom],
    };
  },
  props: ['rev'],
  mixins: [yotpoMixin],
  data() {
    return {
      showModal: false,
      modalImg: 0,
      review: this.rev,
    };
  },
  methods: {
    //show modal for reviews with images
    showFullImg(index) {
      this.showModal = !this.showModal;
      this.modalImg = index;
    },
    imgError(index) {
      //console.log('error at index ' + index);
    },
  },
};
